export enum VectorCommandType {
  M = <any>'M',
  L = <any>'L',
  C = <any>'C',
  Q = <any>'Q',
  Z = <any>'Z'
}
